import {
  DataType as CapabilityDataType,
  Operation as CapabilityOperation,
} from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/capability.pb';
import isEmpty from 'lodash-es/isEmpty';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { useLocalStorage } from '@frontend/web-storage';
import { useGetSchedulerV3FeatureFlagDetails } from './use-get-scheduler-v3-feature-flag-details';

const LOCALSTORAGE_KEY = 'weave.operatory-v3-ff-override';
const FF_NAME = 'scheduler-v3-ui-operatory';

export const useCheckV3OperatorySupport = () => {
  const { featureFlags } = useAppFlagStore();
  const { selectedGroupId } = useAppScopeStore();
  const { getFeatureFlagValue, getFeatureFlagLocationMap } = useScopedAppFlagStore();
  const { isScheduleV3FlagEnabled, isLoading: isLoadingSchedulerV3Flag } = useGetSchedulerV3FeatureFlagDetails();

  const [isOperatoryV3FFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEY,
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEY) === 'true',
  });

  // TODO: Remove isFeatureFlagsLoaded check once getFeatureFlagValue handles loading state internally
  const isFeatureFlagsLoaded = !isEmpty(featureFlags);
  const hasFF = isFeatureFlagsLoaded && getFeatureFlagValue(FF_NAME, 'ALL');

  // Capability check
  const { hasIntegrationCapability: hasListOperatoryCapability, isLoading: isLoadingCreateAppointmentCapability } =
    SchedulerV3.Helpers.useCheckIntegrationCapability(
      { type: CapabilityDataType.OPERATORY, operation: CapabilityOperation.LIST },
      selectedGroupId
    );

  // Integration check
  const { isIntegratedOffice, isLoading: isLoadingIntegrations } = DataSourcesQueries.useGetAccessibleIntegrations();

  const operatoryV3FFLocationMap = getFeatureFlagLocationMap(FF_NAME);
  const isLoading =
    !isFeatureFlagsLoaded || isLoadingCreateAppointmentCapability || isLoadingIntegrations || isLoadingSchedulerV3Flag;
  const isV3OperatorySupported =
    (!isLoading && isScheduleV3FlagEnabled && isIntegratedOffice && hasListOperatoryCapability && hasFF) ||
    isOperatoryV3FFOverride;

  return {
    operatoryV3FFLocationMap,
    isV3OperatorySupported,
    isLoading,
  };
};
